/* eslint-disable */
/**
 * OnlineBedStore — Override the third-party drawer's "View Basket" button.
 *
 * The slide-out drawer that appears after "Add to Basket" is rendered by an
 * external app (HulkApps), so we cannot edit its Liquid. This script watches
 * the DOM for any element with the text "View Basket" / "View Cart" and
 * rewrites it to a "Checkout" link that navigates straight to /checkout.
 * Styling is applied via a class so /assets/cart-checkout-override.css can
 * paint it solid green with white text.
 */
(function () {
  'use strict';

  var ROUTE_CHECKOUT = (window.theme && window.theme.routes && window.theme.routes.cart)
    ? window.theme.routes.cart.replace(/\/cart\/?$/, '/checkout')
    : '/checkout';
  if (!/\/checkout/.test(ROUTE_CHECKOUT)) ROUTE_CHECKOUT = '/checkout';

  var MATCH_TEXTS = ['view basket', 'view cart', 'view my basket', 'view my cart'];

  function isViewBasket(el) {
    if (!el || el.dataset.obsCheckoutOverride === '1') return false;
    var t = (el.textContent || '').trim().toLowerCase().replace(/\s+/g, ' ');
    return MATCH_TEXTS.indexOf(t) !== -1;
  }

  function convert(el) {
    el.dataset.obsCheckoutOverride = '1';

    // Anchor: rewrite href + text in place.
    if (el.tagName === 'A') {
      el.setAttribute('href', ROUTE_CHECKOUT);
      el.removeAttribute('data-no-instant');
      el.textContent = 'Checkout';
      el.classList.add('obs-checkout-cta');
      return;
    }

    // Button (likely a form submit). Replace with an anchor so click goes
    // straight to /checkout — bypasses the cart page entirely.
    var link = document.createElement('a');
    link.href = ROUTE_CHECKOUT;
    link.textContent = 'Checkout';
    link.className = (el.className || '') + ' obs-checkout-cta';
    link.dataset.obsCheckoutOverride = '1';
    if (el.parentNode) el.parentNode.replaceChild(link, el);
  }

  function scan(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    var nodes = scope.querySelectorAll('a, button');
    for (var i = 0; i < nodes.length; i++) {
      if (isViewBasket(nodes[i])) convert(nodes[i]);
    }
  }

  // Watch for the drawer being injected (it renders asynchronously after the
  // Add to Cart click).
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (isViewBasket(node)) {
          convert(node);
        } else if (node.querySelectorAll) {
          scan(node);
        }
      }
    }
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    scan(document);
    // Defensive: rescan periodically for the first few seconds in case the
    // drawer rewrites its own DOM after we've already converted.
    var retries = 0;
    var interval = setInterval(function () {
      scan(document);
      if (++retries >= 20) clearInterval(interval);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
